import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import * as S from './Hero.style';
import * as T from './Hero.types';

export const Hero: React.FC<T.HeroDirectCollection> = ({ description, image, title }) => {
  return (
    <S.BannerPrincipal className="section">
      <S.Container>
        <div className="left">
          <h1>{title}</h1>
          <p className="subtitle">{description}</p>
          <div className="contact">
            <S.Link href="#contato">
              quero testar
              <ArrowRightIcon />
            </S.Link>
          </div>
        </div>
        <div className="right">
          <img src={image.url} alt={title} width={640} height={485} data-lazzy />
        </div>
      </S.Container>
    </S.BannerPrincipal>
  );
};
